<script setup>
import Logo from './Logo.vue'
import { selected, price, state } from './store.js'
import { toMoney } from '@finn-no/finance-lib'
import * as api from './api.js'
import * as track from './tracking.js'

const handleClick = () => {
  selected.value = !selected.value
  const action = selected.value ? 'check' : 'uncheck'
  api.update({ sellerAction: action, values: state })
  track[action]()
}
</script>

<template>
  <f-card
    flat
    class="my-8 px-16 py-24 flex items-start"
    :selected="selected"
  >
    <f-dead-toggle
      v-model="selected"
      checkbox
      class="mt-2"
    />
    <div class="w-16" />
    <div>
      <div class="flex items-center">
        <f-clickable @click="handleClick">
          <p class="font-bold antialiased">
            Garanti fra If Skadeforsikring
          </p>
        </f-clickable>
        <logo class="ml-auto mb-4" />
      </div>
      <ul class="list-checked pointer-events-none">
        <li>Du betaler kun hvis bilen blir solgt</li>
        <li>Merking på annonsen din</li>
        <li>Ekstra trygghet når bilen er solgt</li>
      </ul>
      <h4 class="h3 antialiased mb-0">
        {{ toMoney(price) }}
      </h4>
      <p class="text-14 mb-0">
        for 6 mnd eller til 8000 km
      </p>
    </div>
  </f-card>
</template>
